export default function isAValidOrganizationPathname(pathname, organization) {
  return organization.findIndex(
    (organization) => organization.username === pathname,
  );
}
